export default __webpack_public_path__ + "bbe3340a43a788f574eea49543e279a7.png";